import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import PasteUI from './pasteUI';

export default class Paste extends Plugin {
  static get pluginName() {
    return 'Paste';
  }

  static get requires() {
    return [ PasteUI ];
  }

  insertPlainText(plainText) {
    this.editor.plugins.get(PasteUI).insertPlainText(plainText);
  }
}
